import { computed } from 'vue';

export const face = computed((): 'tri' | 'emissions' | 'tierii' | 'hazwaste' => {
  if (window.location.origin.includes('emissions')) {
    return 'emissions';
  } else if (window.location.origin.includes('tierii')) {
    return 'tierii';
  } else if (window.location.origin.includes('hazwaste')) {
    return 'hazwaste';
  } else {
    return 'tri';
  }
});

export const appTitle = computed((): string => {
  if (face.value === 'tri') {
    return 'TRI';
  } else if (face.value === 'tierii') {
    return 'Tier II';
  } else if (face.value === 'hazwaste') {
    return 'Hazardous Waste';
  } else {
    return 'Emissions';
  }
});
